import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { EmployerDtoPayload } from '@/modules/employer/types';

const QUERY_KEY = 'getEmailTemplatesIdsQueryKey';

export const useGetEmailTemplatesIdsQuery = (id?: string | null) => {
  const { data, isFetched, refetch, isLoading, isSuccess, isError } = useQuery(
    [QUERY_KEY, id],
    () =>
      api.get<EmployerDtoPayload>(API_URL.ORGANIZATIONS_BY_ORGANIZATION_ID(id || ''), {
        headers: {
          'X-DETAILS-RESOLVERS': 'NOTIFICATION_PROPERTIES',
        },
      }),
    {
      enabled: Boolean(id),
    }
  );

  const notificationTemplatesIds = useMemo(() => {
    if (data?.data?.notification_properties) {
      return Object.values(data.data.notification_properties);
    }
    return [];
  }, [data]);

  return {
    data: data?.data,
    notificationProperties: data?.data?.notification_properties,
    notificationTemplatesIds,
    isFetched,
    refetch,
    isLoading,
    isSuccess,
    isError,
  };
};
